export enum Version {
  version_ui = "VERSION",
  mp_cloud = "ISCLOUD"
}
